import { render, staticRenderFns } from "./PlatformValue.vue?vue&type=template&id=7bbb7118&scoped=true"
import script from "./PlatformValue.vue?vue&type=script&lang=js"
export * from "./PlatformValue.vue?vue&type=script&lang=js"
import style0 from "./PlatformValue.vue?vue&type=style&index=0&id=7bbb7118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbb7118",
  null
  
)

export default component.exports